<template>
  <el-row justify="center">
    <el-col :xs="24" :sm="22" :md="20" :lg="18">

      <el-card shadow="never" v-loading="isLoading" class="detail-card">

        <el-alert
          v-if="error"
          :title="error"
          type="error"
          show-icon
          :closable="false"
        />

        <div v-if="activity">

          <h1 class="display-5 fw-bold mb-3">{{ activity.title }}</h1>

          <el-descriptions :column="1" border class="mb-4">
            <el-descriptions-item label="发布于">
              {{ new Date(activity.publish_date).toLocaleString() }}
            </el-descriptions-item>
          </el-descriptions>

          <el-image
            v-if="activity.image"
            :src="activity.image"
            :alt="activity.title"
            fit="cover"
            class="activity-image shadow-sm"
            lazy
          >
            <template #placeholder>
              <div class="image-slot">加载中<span class="dot">...</span></div>
            </template>
          </el-image>

          <h5 class="mt-4">活动详情</h5>
          <pre class="activity-content">{{ activity.content }}</pre>

          <el-divider class="my-4" />

          <el-button @click="$router.push('/home')">
            <i class="fas fa-arrow-left me-2"></i> 返回主页
          </el-button>

        </div>
      </el-card>

    </el-col>
  </el-row>
</template>

<script>
//
// <script> 部分完全保持不变
//
import axios from 'axios';

export default {
  name: 'ActivityDetailView',
  data() {
    return {
      isLoading: true,
      activity: null,
      error: null,
    };
  },
  async mounted() {
    this.isLoading = true; // (确保开始时加载)
    const token = localStorage.getItem('authToken');
    const activityId = this.$route.params.id;

    if (!token || !activityId) {
      this.$router.push('/login');
      return;
    }

    try {
      // 【修改】
      // 我们需要调用【会员区】的 API, 而不是“公开” API
      // (因为 App.vue 会自动把未登录用户挡住)
      const response = await axios.get(`/members/api/activities/${activityId}/`, {
        headers: { 'Authorization': `Token ${token}` }
      });

      this.activity = response.data;

    } catch (err) {
      console.error('获取活动详情失败:', err);
      if (err.response && err.response.status === 404) {
        this.error = "未找到该活动，或该活动已下线。";
      } else {
        this.error = "加载失败，请稍后再试。";
      }
    } finally {
      this.isLoading = false;
    }
  }
};
</script>

<style scoped>
/* --- V4.0 样式 --- */
.detail-card {
  /* 增加内边距 */
  padding: 1rem 2rem;
}
.display-5 {
  font-weight: 600;
  color: var(--el-text-color-primary);
  font-size: 2.25rem; /* 稍小一点 */
  margin-bottom: 1rem !important;
}
.mb-3 {
  margin-bottom: 1.25rem !important;
}
.mb-4 {
  margin-bottom: 1.5rem !important;
}
.mt-4 {
  margin-top: 1.5rem !important;
}
.me-2 {
  margin-right: 0.5rem;
}
.fw-bold {
  font-weight: 600;
}
.text-muted {
  color: var(--el-text-color-secondary);
}

.activity-image {
  width: 100%;
  max-height: 400px;
  object-fit: cover;
  border-radius: 8px;
}
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 200px;
  background: var(--el-fill-color-light);
  color: var(--el-text-color-secondary);
}

.activity-content {
  font-family: inherit;
  font-size: 1.05rem; /* 稍大一点的字体 */
  color: var(--el-text-color-regular);
  white-space: pre-wrap;
  word-wrap: break-word;
  line-height: 1.7;
  background-color: var(--el-fill-color-light);
  padding: 1rem;
  border-radius: 4px;
}
</style>